const Immutable = require('seamless-immutable');
import { formatCitylist } from '../../helper/common-helper';
const defaultState = Immutable.from({
  allNearShopList: {},
  allShopList: {},
  mineAddressList: [],
  errorMessage: '',
  curPosition: {},
  cityList: [],
  load: {
    status: false,
    word: '',
  },
  yunChengSchoolFlag: false,
});

module.exports = (state = defaultState, action) => {
  const {
    type,
    payload,
  } = action;
  switch (type) {
    case 'SET_NEAR_SHOP_LIST': {
      const { noCommercial, cityList = [], cList = [] } = payload;
      return state.setIn(['allNearShopList', 'noCommercial'], noCommercial)
        .setIn(['allNearShopList', 'cityList'], cityList)
        .updateIn(['allNearShopList', 'cList'], shopList => shopList ? shopList.concat(cList || []) : cList || []);
    }
    case 'SET_ALL_SHOP_LIST':
      return state.updateIn(['allShopList', 'cList'], shopList => shopList ? shopList.concat(payload.cList || []) : payload.cList || []);
    case 'CLEAR_ALL_SHOP_LIST':
      return state.setIn(['allShopList', 'cList'], null);
    case 'CLEAR_NEAR_SHOP_LIST':
      return state.setIn(['allNearShopList', 'cList'], null);
    case 'SET_CITY_LIST':
      return state.set('cityList', formatCitylist(payload.cityList || []));
    case 'SET_MINE_ADDRESS_LIST':
      return state.set('mineAddressList', payload || []);
    case 'SET_CUR_POSITION':
      return state.set('curPosition', payload || {});
    case 'SET_ERROR_MSG':
      return state.set('errorMessage', payload || '');
    case 'SET_YCS_SHOP':
      return state.set('yunChengSchoolFlag', !!payload);
    case 'SET_LOAD_MSG':
      {
        return state.set('load', payload);
      }
    default:
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducer/shop-list-ts/index.js